import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { Nav, Tab } from "react-bootstrap";
import Repeatability_Report from "./inner_tab_reports/repeatability_report/Repeatability_Report";
import Reproducibility_Report from "./inner_tab_reports/reproducibility_report/Reproducibility_Report";
import Accuracy_Report from "./inner_tab_reports/accuracy_report/Accuracy_Report";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../features/admin/quality_management/process_requirement/repeatability/Slice";

const Process_Requirement = () => {
  const [show, setShow] = useState(false);

  const tabs = [
    { name: "Repeatability Report", value: 1 },
    { name: "Reproducibility Report", value: 2 },
    { name: "Accuracy Report", value: 3 },
  ];

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeSelectionTypeId, setActiveSelectionTypeId] = useState(1);
  const repeatabilitydetails = useSelector((state) => state.repeatability.data);
  const [searchParams, setSearchParams] = useState({
    test_type_id: null,
    checked_by_id: null,
    certified_value: "",
    end_date: "",
    start_date: "",
  });
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: 10,
        selection_type_id: activeSelectionTypeId,
        test_type_id: searchParams?.test_type_id?.value,
        checked_by_id: searchParams?.checked_by_id?.value,
        certified_value: searchParams?.certified_value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [activeSelectionTypeId, currentPage, searchParams]);

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Process Requirement" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container id="left-tabs-example" defaultActiveKey={tabs[0]?.value}>
          <Nav variant="pills" className="">
            {tabs?.map((item) => {
              return (
                <Nav.Item onClick={() => setActiveSelectionTypeId(item?.value)}>
                  <Nav.Link eventKey={item?.value}>{item?.name}</Nav.Link>
                </Nav.Item>
              );
            })}
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey={1}>
              <Repeatability_Report
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                data={repeatabilitydetails}
                activeSelectionTypeId={activeSelectionTypeId}
              />
            </Tab.Pane>
            <Tab.Pane eventKey={2}>
              <Reproducibility_Report
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                data={repeatabilitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                activeSelectionTypeId={activeSelectionTypeId}
              />
            </Tab.Pane>
            <Tab.Pane eventKey={3}>
              <Accuracy_Report />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Process_Requirement;
